<template>
  <div class="two_switch">
    <div
      v-for="(item, index) in categoriesList[0].childrenCategories"
      :key="index"
      :class="{ choose_item: chooseIndex === index }"
      class="switch_item"
    >
      <div
        :class="{ choose_font: chooseIndex === index }"
        class="item_title"
        @click="TwoSwitch(index, item.name, item.id)"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      cateList: ["全部", "奶粉", "保健品", "化妆品", "红酒", "面膜"],
      chooseIndex: 0
    };
  },
  computed: {
    categoriesList() {
      return this.$store.getters.categoriesList;
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    TwoSwitch(index, name, id) {
      this.chooseIndex = index;
      this.$emit("TwoSwitch", index, name, id);
    }
  }
};
</script>

<style lang="less" scoped>
.two_switch {
  background: #f6f7f8;
  display: flex;
  align-items: center;
  overflow-y: hidden;
  flex-wrap: nowrap;
  justify-content: flex-start;
  .switch_item {
    display: inline-block;
    // width: 100px;
    .item_title {
      width: 100px;
      font-size: 12px;
      font-weight: 500;
      color: #000;
      margin: 10px 0;
      line-height: 17px;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
  .choose_item {
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(193, 200, 207, 0.8);
    border-radius: 0px 0px 6px 6px;

    .choose_font {
      color: #bf9264 !important;
    }
  }
}
</style>
